import { render } from "./CCMerch.vue?vue&type=template&id=2131c012&scoped=true"
const script = {}

import "./CCMerch.vue?vue&type=style&index=0&id=2131c012&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2131c012"]])

export default __exports__